export enum Bereitstellung {
  SYNCHRON = 'Synchron',
  ASYNCHRON = 'Asynchron'
}
